import { render, staticRenderFns } from "./Servicewithotp.vue?vue&type=template&id=3e963c88"
import script from "./Servicewithotp.vue?vue&type=script&lang=js"
export * from "./Servicewithotp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports